/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Role_Admin5Inputs */

const cs_role_admin5 = /** @type {(inputs: Role_Admin5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrátor`)
};

const en_role_admin5 = /** @type {(inputs: Role_Admin5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrator`)
};

/**
* | output |
* | --- |
* | "Administrator" |
*
* @param {Role_Admin5Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
const role_admin5 = /** @type {((inputs?: Role_Admin5Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Role_Admin5Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_role_admin5(inputs)
	return cs_role_admin5(inputs)
});
export { role_admin5 as "role_ADMIN" }